/** Formatting bound to the signed-in user's locale/timezone/currency (QM-D08-003). */
import { formatCurrency, formatDateTime, formatNumber, sanitizeBidi } from '@qm/i18n';
import { useApp } from './app-context';

export function useFormat() {
  const { locale, localePrefs } = useApp();
  const o = { timeZone: localePrefs.timezone, numberingSystem: localePrefs.numberingSystem };
  return {
    date: (iso: string | null | undefined) => (iso ? formatDateTime(locale, iso, { ...o, style: 'date' }) : ''),
    dateTime: (iso: string | null | undefined) => (iso ? formatDateTime(locale, iso, o) : ''),
    time: (iso: string | null | undefined) => (iso ? formatDateTime(locale, iso, { ...o, style: 'time' }) : ''),
    money: (minor: number | null | undefined, currency?: string) => (minor == null ? '' : formatCurrency(locale, minor, currency ?? localePrefs.currency, o)),
    number: (n: number | null | undefined) => (n == null ? '' : formatNumber(locale, n)),
    /** untrusted names/messages: strip bidi overrides (QM-NX-017); render inside <bdi> */
    text: (s: unknown) => sanitizeBidi(String(s ?? '')),
  };
}
